/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Stats_TagsInputs */

const id_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const ms_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const da_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const de_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const en_us2_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const es_es2_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const es_mx2_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const fil_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Tag`)
};

const fr_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const it_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag`)
};

const hu_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Címkék`)
};

const nl_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const no_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagger`)
};

const pl_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagi`)
};

const pt_br2_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const pt_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas`)
};

const ro_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etichete`)
};

const fi_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tagit`)
};

const sv_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taggar`)
};

const vi_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thẻ`)
};

const tr_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiketler`)
};

const cs_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Štítky`)
};

const bg_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Етикети`)
};

const ru_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const uk_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги`)
};

const ar_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الوسوم`)
};

const hi_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग`)
};

const th_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แท็ก`)
};

const ja_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグ`)
};

const zh_cn2_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const zh_hant1_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

const ko_components_stats_tags = /** @type {(inputs: Components_Stats_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags`)
};

/**
* | output |
* | --- |
* | "Tags" |
*
* @param {Components_Stats_TagsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_stats_tags = /** @type {((inputs?: Components_Stats_TagsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Stats_TagsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_stats_tags(inputs)
	if (locale === "ms") return ms_components_stats_tags(inputs)
	if (locale === "da") return da_components_stats_tags(inputs)
	if (locale === "de") return de_components_stats_tags(inputs)
	if (locale === "en-US") return en_us2_components_stats_tags(inputs)
	if (locale === "es-ES") return es_es2_components_stats_tags(inputs)
	if (locale === "es-MX") return es_mx2_components_stats_tags(inputs)
	if (locale === "fil") return fil_components_stats_tags(inputs)
	if (locale === "fr") return fr_components_stats_tags(inputs)
	if (locale === "it") return it_components_stats_tags(inputs)
	if (locale === "hu") return hu_components_stats_tags(inputs)
	if (locale === "nl") return nl_components_stats_tags(inputs)
	if (locale === "no") return no_components_stats_tags(inputs)
	if (locale === "pl") return pl_components_stats_tags(inputs)
	if (locale === "pt-BR") return pt_br2_components_stats_tags(inputs)
	if (locale === "pt") return pt_components_stats_tags(inputs)
	if (locale === "ro") return ro_components_stats_tags(inputs)
	if (locale === "fi") return fi_components_stats_tags(inputs)
	if (locale === "sv") return sv_components_stats_tags(inputs)
	if (locale === "vi") return vi_components_stats_tags(inputs)
	if (locale === "tr") return tr_components_stats_tags(inputs)
	if (locale === "cs") return cs_components_stats_tags(inputs)
	if (locale === "bg") return bg_components_stats_tags(inputs)
	if (locale === "ru") return ru_components_stats_tags(inputs)
	if (locale === "uk") return uk_components_stats_tags(inputs)
	if (locale === "ar") return ar_components_stats_tags(inputs)
	if (locale === "hi") return hi_components_stats_tags(inputs)
	if (locale === "th") return th_components_stats_tags(inputs)
	if (locale === "ja") return ja_components_stats_tags(inputs)
	if (locale === "zh-CN") return zh_cn2_components_stats_tags(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_stats_tags(inputs)
	return ko_components_stats_tags(inputs)
});
export { components_stats_tags as "components.stats.tags" }